import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import "./ApplyModal.css";

const ApplyModal = ({ isOpen, onClose, onSubmit, positions }) => {
  const [selectedPosition, setSelectedPosition] = useState(0);
  const [motivation, setMotivation] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validation
    if (motivation.trim().length < 50) {
      setError("Motivation must be at least 50 characters");
      return;
    }

    if (motivation.trim().length > 1000) {
      setError("Motivation must be at most 1000 characters");
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit(motivation.trim(), selectedPosition);
      // Reset form
      setMotivation("");
      setSelectedPosition(0);
      setError("");
    } catch (err) {
      setError("Failed to submit application");
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!submitting) {
      setMotivation("");
      setSelectedPosition(0);
      setError("");
      onClose();
    }
  };

  const charCount = motivation.trim().length;
  const isValid = charCount >= 50 && charCount <= 1000;

  return (
    <div className="apply-modal-overlay" onClick={handleClose}>
      <div className="apply-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="apply-modal-header">
          <h2>Apply for Position</h2>
          <button
            className="apply-modal-close"
            onClick={handleClose}
            disabled={submitting}
          >
            <FaTimes />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="apply-modal-form">
          {/* Position Selection */}
          <div className="form-group">
            <label htmlFor="position-select">Select Position *</label>
            <select
              id="position-select"
              value={selectedPosition}
              onChange={(e) => setSelectedPosition(Number(e.target.value))}
              disabled={submitting}
              required
            >
              {positions.map((position, index) => (
                <option key={index} value={index}>
                  {position.role} ({position.filled || 0}/{position.count}{" "}
                  filled)
                </option>
              ))}
            </select>
          </div>

          {/* Motivation */}
          <div className="form-group">
            <label htmlFor="motivation-text">
              Why do you want to join this collaboration? *
            </label>
            <textarea
              id="motivation-text"
              value={motivation}
              onChange={(e) => setMotivation(e.target.value)}
              placeholder="Explain your interest, relevant experience, and what you can contribute..."
              rows={8}
              maxLength={1000}
              disabled={submitting}
              required
            />
            <div className="char-counter">
              <span
                className={`char-count ${
                  charCount < 50
                    ? "invalid"
                    : charCount > 1000
                    ? "over-limit"
                    : "valid"
                }`}
              >
                {charCount}/1000 characters
              </span>
              {charCount < 50 && (
                <span className="min-requirement">
                  (minimum 50 characters required)
                </span>
              )}
            </div>
          </div>

          {/* Error Message */}
          {error && <div className="error-message">{error}</div>}

          {/* Actions */}
          <div className="apply-modal-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={handleClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-btn"
              disabled={!isValid || submitting}
            >
              {submitting ? "Submitting..." : "Submit Application"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ApplyModal;
